<div class="opt-toast-message">
    <!--<button class="mat-btn-primary btn-error" mat-button (click)="openSnackBarError()">Error</button>
    <button class="mat-btn-primary btn-warning" mat-button (click)="openSnackBarWarning()">Warning</button>
    <button class="mat-btn-primary btn-success" mat-button (click)="openSnackBarSuccess()">Success</button>-->
</div>
<div class="opt-toast-message">
    <button class="mat-btn-primary btn-error" mat-button (click)="openDialogError()" (keydown.enter)="openDialogError()" tabindex="0">Error Dialog</button>
</div>